export default __webpack_public_path__ + "static/media/Marketplacelogo.6bfeaea1.svg";